module.exports = __webpack_public_path__ + "img/font_slogand.4cc5d44.svg";